import { resolveFormSchemaIdFromPageEntry } from '@/common/utils/resolvePageIdentity'
import { formHasRenderableLayout } from '@/services/parse/parse.service'

const normalizeSchemaId = (value: unknown): string => {
  if (value == null) return ''
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return String(value)
  }
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed || trimmed === '0') return ''
    const parsed = parseInt(trimmed, 10)
    if (Number.isFinite(parsed) && parsed > 0) return String(parsed)
  }
  return ''
}

/**
 * Не переносить states/form_id дочерней формы на слот с чужой разметкой
 */
export function isolateJsResultForSlotMerge(
  slotId: string,
  oldData: Record<string, any>,
  data: Record<string, any>,
): void {
  if (!oldData?.jsResult || !data.jsResult || typeof data.jsResult !== 'object') {
    return
  }

  const slotSchemaId = normalizeSchemaId(resolveFormSchemaIdFromPageEntry(oldData, slotId))
  if (!slotSchemaId) return

  const incomingSchemaId = normalizeSchemaId(
    data.jsResult.form_id ?? resolveFormSchemaIdFromPageEntry(data, slotId),
  )

  const layoutChanging =
    data.form != null &&
    formHasRenderableLayout(data.form) &&
    normalizeSchemaId(resolveFormSchemaIdFromPageEntry(data, slotId)) !== slotSchemaId

  if (layoutChanging || !incomingSchemaId || incomingSchemaId === slotSchemaId) {
    return
  }

  data.jsResult = {
    ...data.jsResult,
    form_id: oldData.jsResult.form_id ?? slotSchemaId,
    states: oldData.jsResult.states,
  }
}
